<div class="upload-panel-wrapper">
  <div *ngIf="config.data.panelTitle" class="title">
    <h4>{{config.data.panelTitle}}</h4>
  </div>
  <div class="uploaded-file-name">
    file caricato: <span><b>{{config.data.file.title}}</b></span>
  </div>
  <app-dynamic-form [questions]="formFields" [config]="formConfiguration"
    (onFormSubmit)="sendFileElaboration($event)"></app-dynamic-form>
</div>
